export const SessionStorageKeys = {
  CSRF_TOKEN: "sara_csrf_token",
};
